import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PagedResult } from '../../interfaces';
import { Queries } from './queries';

@Injectable({
  providedIn: 'root'
})
export class LabelsApi {
  constructor(private apollo: Apollo, private queries: Queries) {}

  getLabels(where?, offset?: number): Observable<PagedResult> {
    return this.apollo
      .query({
        query: this.queries.getLabels(),
        variables: {
          where,
          offset
        }
      })
      .pipe(
        map(({ data }) => {
          return data['labels'];
        })
      );
  }
}
